import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'

import FormRender, { FormResourceType } from 'modules/forms/components/FormRender'

type Data = {
  formId: string
  resourceType: FormResourceType
  membershipId?: string
}

export const PreviewFormActivity: ActivityComponent<Data> = ({
  formId,
  membershipId,
  resourceType,
}) => {
  const { open, closeActivity } = useActivity()

  return (
    <FormRender
      formId={formId}
      resourceType={resourceType}
      isOpen={open}
      onClose={closeActivity}
      onSubmitSuccess={closeActivity}
      mode="preview"
      membershipId={membershipId}
    />
  )
}
